<!--
    @负责人: 李小华
    @创建时间: 2021-06-25
    @版本:v1.0.12
    @描述: 应用日志字段路由页面
-->
<template>
  <div class="appLogFieldRouteConfig__content">
    <el-form ref="form"
      :model="form"
      :inline="true"
      input-width="auto">
      <el-form-item :label="$t('logComponentManage.group')">
        <g-select :list="groupList"
          v-model="form.group"
          :default-all="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('logComponentManage.appName')">
        <g-select :list="selectAppList"
          v-model="form.appName"
          :default-all="true"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
          @click="e_search"
          v-g-rac="gRac('appLogFieldRouteConfig_search')">{{ $t('common.search') }}</el-button>
        <el-button type="primary"
          @click="e_add()"
          v-g-rac="gRac('appLogFieldRouteConfig_add')">{{ $t('logComponentManage.add') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table-extend :data="tData"
      :head="tHead"
      :currentChange="tCurrentChange"
      :sizeChange="tSizeChange"
      border>
      <template slot="control-column"
        slot-scope="{data}">
        <el-table-extend-control :control="tableControl"
          :data="data"
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false"
      :title="dialogTitle"
      :visible.sync="dialogFormShow"
      width="750px">
      <el-form :model="routeForm"
        label-position="right"
        label-width="120px"
        ref="routeForm"
        :rules="dialogFormRule">
        <el-form-item :label="$t('logComponentManage.group')"
          prop="group">
          <g-select :list="groupList"
            v-model="routeForm.group"
            :tdisabled="readOnly"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.appName')">
          <g-select :list="selectAppListForAdd"
            v-model="routeForm.appName"
            :default-all="true"
            :tdisabled="readOnly"
            v-show="!isEdit"></g-select>
          <el-input v-model="routeForm.appName2"
            :disabled="read"
            v-show="isEdit"></el-input>
        </el-form-item>
        <el-form-item input-width="550px"
          :label="$t('logComponentManage.config')">
          <dynamic-table ref="dynamicTable"
            :input-data="inputData"
            :model="tableModel"
            :custom-fun="deleteDdata">
          </dynamic-table>
        </el-form-item>
      </el-form>
      <div slot="footer"
        class="dialog-footer">
        <el-button @click="e_cancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary"
          @click="e_save">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
        
<script >
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import systemSettingBiz from "@/logic/systemSetting/systemSettingBiz.js";
import dialogForm from "@/components/dialogForm";
import validateConfig from "@/utils/validate";
import dynamicTable from "@/components/dynamicTable.vue";
import { extend, getKeyByValue } from "@/utils/tool";
export default {
  mixins: [rac, dic, table],
  components: {
    dialogForm,
    dynamicTable
  },
  props: ["siteCode"],
  data() {
    const that = this;
    return {
      form: {
        group: "",
        appName: ""
      },
      routeForm: {
        group: "",
        appName: ""
      },
      selectAppListForAdd: {},
      selectAppList: {},
      tableControl: [
        {
          label: that.$t("common.edit"),
          callback: that.e_add,
          rac: () => that.gRac("appLogFieldRouteConfig_edit")
        },
        {
          label: that.$t("common.delete"),
          callback: that.e_delete,
          rac: () => that.gRac("appLogFieldRouteConfig_delete")
        }
      ],
      dialogFormShow: false,
      dialogTitle: "",
      dialogFormRule: {
        group: [{ ...validateConfig.common.notEmpty }]
      },
      inputData: [],
      tableModel: {},
      isEdit: false,
      topicListNew: {},
      readOnly: false,
      read: true,
      init: true,
      groupList: {}
    };
  },
  computed: {},
  methods: {
    async waitAppList(group, val) {
      await this.$store.dispatch("resetAppByGroup", {
        siteCode: this.siteCode,
        group: group
      });
      // await this.dGetAppByGroup(this.siteCode, group)
      if (val === 1) {
        this.selectAppList = { ...this.dDictionaryApp[group] };
        this.form.appName = "";
      } else {
        this.selectAppListForAdd = { ...this.dDictionaryApp[group] };
        this.routeForm.appName = "";
      }
    },
    async preInitTable() {
      this.setDynamicData();
      await Promise.all([
        this.dGetGroup(this.siteCode, true),
        this.dGetDictionaryByCode("logLevel"),
        this.getTopic()
      ]);
      this.groupList = this.$store.state.dicModule.group;
      this.initTable();
      // this.setDynamicData();
    },
    e_search() {
      this.tResetPage();
      this.search();
    },
    getTopic() {
      this.topicListNew = clearObj(this.topicListNew);
      return systemSettingBiz.getTopic().then(data => {
        data.map(item => {
          this.topicListNew[item.topic] = item.topic;
        });
      });
      function clearObj(obj) {
        for (let k in obj) {
          delete obj[k];
        }
        return obj;
      }
    },
    initTable() {
      this.tInitTable({
        lanKey: "logComponentManage.table",
        head: ["group", "appName"],
        requestFun: this.search,
        headOpt: {
          group: {
            formatter: "Dictionary",
            formatterDic: this.groupList
          }
        }
      });
    },
    setDynamicData() {
      this.inputData = [
        {
          label: this.$t("logComponentManage.key"),
          key: "field"
        },
        {
          label: this.$t("logComponentManage.value"),
          key: "value"
        },
        {
          label: this.$t("logComponentManage.topic"),
          key: "topic",
          type: "select",
          select: this.topicListNew
        },
        {
          label: this.$t("logComponentManage.priority"),
          key: "order"
        }
      ];
      this.tableModel = {
        field: "",
        topic: Object.keys(this.topicListNew)[0],
        value: "",
        order: 0
      };
    },
    search() {
      const reqData = extend(true, { ...this.tPageInfo }, this.form);
      let params = new URLSearchParams();
      Object.keys(reqData).map(key => {
        params.append(key, reqData[key]);
      });
      systemSettingBiz
        .queryFieldRouteConfig(params)
        .then(data => {
          this.tData = data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    async e_add(rowData) {
      await this.getTopic();
      this.dialogFormShow = true;
      this.readOnly = this.isEdit = !!rowData;
      this.dialogTitle = this.isEdit
        ? this.$t("logComponentManage.change")
        : this.$t("logComponentManage.add");
      this.$nextTick(() => {
        if (this.isEdit) {
          let tableData = [];
          rowData.fieldRoute.map(item => {
            tableData.push(extend(true, {}, item));
          });
          this.$refs.dynamicTable.setData(tableData);
          this.routeForm = {
            group: getKeyByValue(this.groupList, rowData.group),
            appName: rowData.appName,
            appName2: rowData.appName,
            id: rowData.id
          };
        } else {
          this.$refs.dynamicTable.setData([]);
          this.routeForm = {
            group: "",
            appName: ""
          };
        }
      });
    },
    e_cancel() {
      this.dialogFormShow = false;
    },
    e_save() {
      const reqData = extend(true, {}, this.routeForm);
      reqData.siteCode = this.siteCode;
      reqData.fieldRoute = this.$refs.dynamicTable.getData();
      this.$refs.routeForm.validate(valid => {
        if (!valid) return;
        let handleName = "addFieldRouteConfig";
        if (this.isEdit) {
          handleName = "updateFieldRouteConfig";
          reqData.appName = reqData.appName2;
        }
        delete reqData.appName2;
        systemSettingBiz[handleName](reqData).then(() => {
          this.$message({
            message: this.$t("common.success"),
            type: "success"
          });
          setTimeout(() => {
            this.dialogFormShow = false;
            this.e_search();
          }, 500);
        });
      });
    },
    e_delete(rowData) {
      let params = new URLSearchParams();
      params.append("id", rowData.id);
      params.append("siteCode", this.siteCode);
      this.$confirm(this.$t("common.deleteTips"), this.$t("common.tips"), {
        type: "warning"
      })
        .then(() => {
          systemSettingBiz.deleteFieldRouteConfig(params).then(data => {
            this.$message({
              message: this.$t("common.success"),
              type: "success"
            });
            this.search();
          });
        })
        .catch(() => {});
    },
    deleteDdata(item, i) {
      const d = this.$refs.dynamicTable.getData();
      d.splice(i, 1);
      this.$refs.dynamicTable.setData(d);
    }
  },
  mounted() {},
  watch: {
    "form.group"() {
      this.waitAppList(this.form.group, 1);
    },
    "routeForm.group"() {
      this.waitAppList(this.routeForm.group, 2);
    },
    siteCode() {
      if (this.init) {
        this.init = false;
        this.preInitTable();
        this.e_search();
      } else {
        this.e_search();
      }
    }
  }
};
</script>
        
        
        
        
        
        
        
        